import React, { Component, Suspense, lazy } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Spinner from '../app/shared/Spinner';
import User from '../model/Users';

const Dashboard = lazy(() => import('./dashboard/Dashboard'));

const Login = lazy(() => import('./auth/Login'));

// report qris 
const reportMerchant = lazy(() => import('./report_qris/ReportMerchant'))
const DashboardMonitoringTransaksi = lazy(() => import('./report_qris/DashboardMonitoringTransaksi'))
const DashboardMonitoringUserMitra = lazy(() => import('./report_qris/DashboardMonitoringUserMitra'))

// setting
const GeneralSetting = lazy(() => import('./setting/GeneralSetting'))
// privilege management
const PrivilegeManagement = lazy(() => import('./setting/PrivilegeManagement/PrivilegeManagement'))
const EditPrivilegeManagement = lazy(() => import('./setting/PrivilegeManagement/EditPrivilegeManagement'))
const AddPrivilegeManagement = lazy(() => import('./setting/PrivilegeManagement/AddPrivilegeManagement'))
// user management 
const UserManagement = lazy(() => import('./setting/UserManagement/UserManagement'))
const AddUserManagement = lazy(() => import('./setting/UserManagement/AddUserManagement'))
const EditUserManagement = lazy(() => import('./setting/UserManagement/EditUserManagement'))
// nns managemetn 

const NnsManagement = lazy(() => import('./setting/NnsManagement/NnsManagement'))
const EditNnsManagement = lazy(() => import('./setting/NnsManagement/EditNnsManagement'))
const AddNnsManagement = lazy(() => import('./setting/NnsManagement/AddNnsManagement'))

// mcc management
const MccManagement = lazy(() => import('./setting/MccManagement/MccManagement'))
const EditMccManagement = lazy(() => import('./setting/MccManagement/EditMccManagement'))
const AddMccManagement = lazy(() => import('./setting/MccManagement/AddMccManagement'))

// fee merchant aggregator 
const FeeMerchantAggregator = lazy(() => import('./setting/FeeMerchantAggregator/FeeMerchantAggregator'))
const EditFeeMerchantAggregator = lazy(() => import('./setting/FeeMerchantAggregator/EditFeeMerchantAggregator'))
const AddFeeMerchantAggregator = lazy(() => import('./setting/FeeMerchantAggregator/AddFeeMerchantAggregator'))
// fee issuer cobrand

const FeeIssuerCoBrand = lazy(() => import('./setting/FeeIssuerCoBrand/FeeIssuerCoBrand'))
const AddFeeIssuerCoBrand = lazy(() => import('./setting/FeeIssuerCoBrand/AddFeeIssuerCoBrand'))
const EditFeeIssuerCoBrand = lazy(() => import('./setting/FeeIssuerCoBrand/EditFeeIssuerCoBrand'))

// mitra-management
const ManagementMitra = lazy(() => import('./setting/ManagementMitra/ManagementMitra'))
const EditManagementMitra = lazy(() => import('./setting/ManagementMitra/EditManagementMitra'))
const AddManagementMitra = lazy(() => import('./setting/ManagementMitra/AddManagementMitra'))

// referral
const ReferralList = lazy(() => import('./setting/Referral/ReferralList'))
const ReferralAdd = lazy(() => import('./setting/Referral/ReferralAdd'))
const ReferralEdit = lazy(() => import('./setting/Referral/ReferralEdit'))
const ReferralImport = lazy(() => import('./setting/Referral/ReferralImport'))

// merchant criteria
const MerchantCriteriaList = lazy(() => import('./setting/Criteria/MerchantCriteriaList'))
const MerchantCriteriaAdd = lazy(() => import('./setting/Criteria/MerchantCriteriaAdd'))
const MerchantCriteriaEdit = lazy(() => import('./setting/Criteria/MerchantCriteriaEdit'))

// management merchant
const MerchantManagementList = lazy(() => import('./setting/MerchantManagement/MerchantManagementList'))
const MerchantManagementAdd = lazy(() => import('./setting/MerchantManagement/MerchantManagementAdd'))
const MerchantManagementEdit = lazy(() => import('./setting/MerchantManagement/MerchantManagementEdit'))

// bank
const BankList = lazy(() => import('./setting/Bank/BankList'))
const BankAdd = lazy(() => import('./setting/Bank/BankAdd'))
const BankEdit = lazy(() => import('./setting/Bank/BankEdit'))

// province
const ProvinceList = lazy(() => import('./setting/ManagemenetAddress/Province/ProvinceList'))
const ProvinceAdd = lazy(() => import('./setting/ManagemenetAddress/Province/ProvinceAdd'))
const ProvinceEdit = lazy(() => import('./setting/ManagemenetAddress/Province/ProvinceEdit'))

// postal code
const PostalCodeList = lazy(() => import('./setting/ManagemenetAddress/PostalCode/PostalCodeList'))
const PostalCodeAdd = lazy(() => import('./setting/ManagemenetAddress/PostalCode/PostalCodeAdd'))
const PostalCodeEdit = lazy(() => import('./setting/ManagemenetAddress/PostalCode/PostalCodeEdit'))

// mcc group
const MccGroupList = lazy(() => import('./setting/MccGroupManagement/MccGroupList'))
const MccGroupAdd = lazy(() => import('./setting/MccGroupManagement/MccGroupAdd'))
const MccGroupEdit = lazy(() => import('./setting/MccGroupManagement/MccGroupEdit'))

// ganti Password
const GantiPassword = lazy(() => import('./GantiPassword/GantiPassword'))

// List Merchant
const ListMerchant = lazy(() => import('./Merchants/ListMerchant/ListMerchant'))
const EditMerchantListMerchant = lazy(() => import('./Merchants/ListMerchant/EditMerchantListMerchant'))

// List Bluk
const ListBulk = lazy(() => import('./Merchants/ListBulk/ListBulk'))
const EditListBulk = lazy(() => import('./Merchants/ListBulk/EditListBulk'))
const UploadBulk = lazy(() => import('./Merchants/ListBulk/UploadBulk'))
// Pten Upload Scheduler
const PtenUploadScheduler = lazy(() => import('./Merchants/PtenUploadScheduler/PtenUploadScheduler'))
const PtenUploadSetting = lazy(() => import('./Merchants/PtenUploadScheduler/PtenUploadSetting'))

// Pten Download Scheduler
const PtenDownloadScheduler = lazy(() => import('./Merchants/PtenDownloadScheduler/PtenDownloadScheduler'))
const PtenDownloadSetting = lazy(() => import('./Merchants/PtenDownloadScheduler/PtenDownloadSetting'))


// upload pten
const UploadPten = lazy(() => import('./Merchants/UploadPten/UploadPten'))

// registraion merchant 
const RegisterMerchant = lazy(() => import('./Merchants/RegisterMerchant/RegisterMerchant'))


// apprival 
const ApprovalMerchant = lazy(() => import('./Merchants/ApprovalMerchant/ApprovalMerchant'))
const ViewMerchant = lazy(() => import('./Merchants/ApprovalMerchant/ViewMerchant'))
const EditMerchantWaitingApproval = lazy(() => import('./Merchants/ApprovalMerchant/EditMerchantWaitingApproval'))
const EditMerchantApprovalPten = lazy(() => import('./Merchants/ApprovalMerchant/EditMerchantApprovalPten'))
const EditMerchantReject = lazy(() => import('./Merchants/ApprovalMerchant/EditMerchantReject'))

// mitra akuisisi
const MitraAkuisisiList = lazy(() => import('./Merchants/MitraAkuisisi/MitraAkuisisiList'))
const MitraAkuisisiAdd = lazy(() => import('./Merchants/MitraAkuisisi/MitraAkuisisiAdd'))
const MitraAkuisisiEdit = lazy(() => import('./Merchants/MitraAkuisisi/MitraAkuisisiEdit'))
const MitraAkuisisiShow = lazy(() => import('./Merchants/MitraAkuisisi/MitraAkuisisiShow'))

// mcc group
const FeeQrisList = lazy(() => import('./Merchants/FeeQris/FeeQrisList'))
const FeeQrisAdd = lazy(() => import('./Merchants/FeeQris/FeeQrisAdd'))
const FeeQrisEdit = lazy(() => import('./Merchants/FeeQris/FeeQrisEdit'))

// self-register
const SelfRegister = lazy(() => import('./SelfRegister/SelfRegister'))

// create password
const CreatePassword = lazy(() => import('./createPassword/CreatePassword'))

const Welcome = lazy(() => import('./welcome/Welcome'))

const ForgotPassword = lazy(() => import('./forgotPassword/ForgotPassword'))
const Reset = lazy(() => import('./forgotPassword/Reset'))

// mobile
// banner
const BannerList = lazy(() => import('./mobile/Banner/BannerList'))
const BannerAdd = lazy(() => import('./mobile/Banner/BannerAdd'))
const BannerEdit = lazy(() => import('./mobile/Banner/BannerEdit'))


// blast notif
const BlastNotifList = lazy(() => import('./mobile/BlastNotif/BlastNotifList'))
const BlastNotifAdd = lazy(() => import('./mobile/BlastNotif/BlastNotifAdd'))
const BlastNotifEdit = lazy(() => import('./mobile/BlastNotif/BlastNotifEdit'))

// blast notif
const POS_UserList = lazy(() => import('./mobile/POS_User/POS_UserList'))

// blast notif
const POS_PriceList = lazy(() => import('./mobile/POS_Price/POS_PriceList'))
const POS_PriceAdd = lazy(() => import('./mobile/POS_Price/POS_PriceAdd'))
const POS_PriceEdit = lazy(() => import('./mobile/POS_Price/POS_PriceEdit'))


// protectComponent 
const ProtectComponent = () => {

  return (
    <div>
      
      {User.getPrivilage().indexOf("dashboard") === -1 ?
        <Route exact path="/" component={Welcome} />
        : <Route exact path="/" component={Dashboard} />}
      {User.getPrivilage().indexOf("dashboard") !== -1 ?
        <Route exact path="/dashboard" component={Dashboard} />
        : null}

      {/* report qris */}
      {User.getPrivilage().indexOf("report-merchant") !== -1 || User.get().user_type == "merchant" ?
        <Route exact path="/report/report-merchant" component={reportMerchant} />
        : null}

        {/* dashboard-monitoring-transaksi */}
      {User.getPrivilage().indexOf("dashboard-monitoring-transaksi") !== -1  ?
        <Route exact path="/report/dashboard-monitoring-transaksi" component={DashboardMonitoringTransaksi} />
        : null}

         {/* dashboard-monitoring-user-mitra */}
      {User.getPrivilage().indexOf("dashboard-monitoring-user-mitra") !== -1  ?
        <Route exact path="/report/dashboard-monitoring-user-mitra" component={DashboardMonitoringUserMitra} />
        : null}

      {/* setting  */}
      {User.getPrivilage().indexOf("general-setting") !== -1 ?
        <Route exact path="/setting/general-setting" component={GeneralSetting} />
        : null}

      {/* privilege management */}
      {User.getPrivilage().indexOf("privilege-management") !== -1 ?
        <Route exact path="/setting/privilege-management" component={PrivilegeManagement} />
        : null}

      {User.getPrivilage().indexOf("privilege-management") !== -1 ?
        <Route exact path="/setting/privilege-management/edit/:id" component={EditPrivilegeManagement} />
        : null}

      {User.getPrivilage().indexOf("privilege-management") !== -1 ?
        <Route exact path="/setting/privilege-management/add" component={AddPrivilegeManagement} />
        : null}

      {/* user management */}
      {User.getPrivilage().indexOf("user-management") !== -1 ?
        <Route exact path="/setting/user-management" component={UserManagement} />
        : null}

      {User.getPrivilage().indexOf("user-management") !== -1 ?
        <Route exact path="/setting/user-management/add" component={AddUserManagement} />
        : null}

      {User.getPrivilage().indexOf("user-management") !== -1 ?
        <Route exact path="/setting/user-management/edit/:id" component={EditUserManagement} />
        : null}

      {/* NNS Management */}
      {User.getPrivilage().indexOf("nss-management") !== -1 ?
        <Route exact path="/setting/nns-management" component={NnsManagement} />
        : null}

      {User.getPrivilage().indexOf("nss-management") !== -1 ?
        <Route exact path="/setting/nns-management/edit/:id" component={EditNnsManagement} />
        : null}

      {User.getPrivilage().indexOf("nss-management") !== -1 ?
        <Route exact path="/setting/nns-management/add" component={AddNnsManagement} />
        : null}

      {/* MCC Managemement */}
      {User.getPrivilage().indexOf("mcc-management") !== -1 ?
        <Route exact path="/setting/mcc-management" component={MccManagement} />
        : null}

      {User.getPrivilage().indexOf("mcc-management") !== -1 ?
        <Route exact path="/setting/mcc-management/edit/:id" component={EditMccManagement} />
        : null}

      {User.getPrivilage().indexOf("mcc-management") !== -1 ?
        <Route exact path="/setting/mcc-management/add" component={AddMccManagement} />
        : null}

      {/* SETTING FEE MERCHANT AGGREGATOR */}
      {User.IsLogin() && User.getPrivilage().indexOf("fee-issuer") !== -1 ? <div>
        <Route exact path="/setting/fee-acquirer" component={FeeMerchantAggregator} />
        <Route exact path="/setting/fee-acquirer/edit/:id" component={EditFeeMerchantAggregator} />
        <Route exact path="/setting/fee-acquirer/add" component={AddFeeMerchantAggregator} />
      </div> : null}
      {/* fee issuer cobrand */}
      {User.getPrivilage().indexOf("mcc-management") !== -1 ?
        <Route exact path="/setting/fee-issuer" component={FeeIssuerCoBrand} />
        : null}

      {User.getPrivilage().indexOf("fee-issuer") !== -1 ?
        <Route exact path="/setting/fee-issuer/edit/:id" component={EditFeeIssuerCoBrand} />
        : null}

      {User.getPrivilage().indexOf("fee-issuer") !== -1 ?
        <Route exact path="/setting/fee-issuer/add" component={AddFeeIssuerCoBrand} />
        : null}

      {/* mitra-management */}
      {User.getPrivilage().indexOf("mitra-management") !== -1 ?
        <Route exact path="/setting/mitra-management" component={ManagementMitra} />
        : null}
      {User.getPrivilage().indexOf("mitra-management") !== -1 ?
        <Route exact path="/setting/mitra-management/edit/:id" component={EditManagementMitra} />
        : null}
      {User.getPrivilage().indexOf("mitra-management") !== -1 ?
        <Route exact path="/setting/mitra-management/add" component={AddManagementMitra} />
        : null}
      
      {/* referral */}
      {User.getPrivilage().indexOf("referral") !== -1 ?
        <Route exact path="/setting/referral" component={ReferralList} />
        : null}
      {User.getPrivilage().indexOf("referral") !== -1 ?
        <Route exact path="/setting/referral/add" component={ReferralAdd} />
        : null}
      {User.getPrivilage().indexOf("referral") !== -1 ?
        <Route exact path="/setting/referral/edit/:id" component={ReferralEdit} />
        : null}
      {User.getPrivilage().indexOf("referral") !== -1 ?
        <Route exact path="/setting/referral/import" component={ReferralImport} />
        : null}
      
      {/* merchant criteria */}
      {User.getPrivilage().indexOf("criteria") !== -1 ?
        <Route exact path="/setting/criteria" component={MerchantCriteriaList} />
        : null}
      {User.getPrivilage().indexOf("criteria") !== -1 ?
        <Route exact path="/setting/criteria/add" component={MerchantCriteriaAdd} />
        : null}
      {User.getPrivilage().indexOf("criteria") !== -1 ?
        <Route exact path="/setting/criteria/edit/:id" component={MerchantCriteriaEdit} />
        : null}

      {/* merchant management */}
      {User.getPrivilage().indexOf("management-merchant-mitra") !== -1 ?
        <Route exact path="/setting/management-merchant-mitra" component={MerchantManagementList} />
        : null}
      {User.getPrivilage().indexOf("management-merchant-mitra") !== -1 ?
        <Route exact path="/setting/management-merchant-mitra/add" component={MerchantManagementAdd} />
        : null}
      {User.getPrivilage().indexOf("management-merchant-mitra") !== -1 ?
        <Route exact path="/setting/management-merchant-mitra/edit/:id" component={MerchantManagementEdit} />
        : null}
        
      {/* bank */}
      {User.getPrivilage().indexOf("bank") !== -1 ?
        <Route exact path="/setting/bank" component={BankList} />
        : null}
      {User.getPrivilage().indexOf("bank") !== -1 ?
        <Route exact path="/setting/bank/add" component={BankAdd} />
        : null}
      {User.getPrivilage().indexOf("bank") !== -1 ?
        <Route exact path="/setting/bank/edit/:id" component={BankEdit} />
        : null}
        
      {/* province */}
      {User.getPrivilage().indexOf("province") !== -1 ?
        <Route exact path="/setting/management-alamat/province" component={ProvinceList} />
        : null}
      {User.getPrivilage().indexOf("province") !== -1 ?
        <Route exact path="/setting/management-alamat/province/add" component={ProvinceAdd} />
        : null}
      {User.getPrivilage().indexOf("province") !== -1 ?
        <Route exact path="/setting/management-alamat/province/edit/:id" component={ProvinceEdit} />
        : null}
      
      {/* postal code */}
      {User.getPrivilage().indexOf("postal-code") !== -1 ?
        <Route exact path="/setting/management-alamat/postal-code" component={PostalCodeList} />
        : null}
      {User.getPrivilage().indexOf("postal-code") !== -1 ?
        <Route exact path="/setting/management-alamat/postal-code/add" component={PostalCodeAdd} />
        : null}
      {User.getPrivilage().indexOf("postal-code") !== -1 ?
        <Route exact path="/setting/management-alamat/postal-code/edit/:id" component={PostalCodeEdit} />
        : null}
        
      {/* postal code */}
      {User.getPrivilage().indexOf("mcc-group") !== -1 ?
        <Route exact path="/setting/mcc-group" component={MccGroupList} />
        : null}
      {User.getPrivilage().indexOf("mcc-group") !== -1 ?
        <Route exact path="/setting/mcc-group/add" component={MccGroupAdd} />
        : null}
      {User.getPrivilage().indexOf("mcc-group") !== -1 ?
        <Route exact path="/setting/mcc-group/edit/:id" component={MccGroupEdit} />
        : null}

      {/* ganti Password */}
      <Route exact path="/ganti-password" component={GantiPassword} />

      {/* list Merchant */}
      {User.getPrivilage().indexOf("merchant-management") !== -1 ?
        <Route exact path="/merchant/management" component={ListMerchant} />
        : null}
      {User.getPrivilage().indexOf("merchant-management") !== -1 ?
        <Route exact path="/merchant/management/edit/:id" component={EditMerchantListMerchant} />
        : null}

      {/* upload pten  */}
      {User.getPrivilage().indexOf("merchant-management") !== -1 ?
        <Route exact path="/merchant/upload-to-pten" component={UploadPten} />
        : null}

        {/* list bluk */}
        {User.getPrivilage().indexOf("list-bulk") !== -1 ?
        <Route exact path="/merchant/list-bulk" component={ListBulk} />
        : null}
        {User.getPrivilage().indexOf("list-bulk") !== -1 ?
        <Route exact path="/merchant/list-bulk/:id" component={EditListBulk} />
        : null}
         {User.getPrivilage().indexOf("list-bulk") !== -1 ?
        <Route exact path="/merchant/list-bulk-upload" component={UploadBulk} />
        : null}

       {/* pten download scheduler */}
       {User.getPrivilage().indexOf("pten-download-scheduler") !== -1 ?
        <Route exact path="/merchant/pten-download-scheduler" component={PtenDownloadScheduler} />
        : null}
       {User.getPrivilage().indexOf("pten-download-scheduler") !== -1 ?
        <Route exact path="/merchant/pten-download-scheduler/setting" component={PtenDownloadSetting} />
        : null}


         {/* pten upload scheduler */}
       {User.getPrivilage().indexOf("pten-upload-scheduler") !== -1 ?
        <Route exact path="/merchant/pten-upload-scheduler" component={PtenUploadScheduler} />
        : null}
       {User.getPrivilage().indexOf("pten-upload-scheduler") !== -1 ?
        <Route exact path="/merchant/pten-upload-scheduler/setting" component={PtenUploadSetting} />
        : null}
        
        {/* mitra akuisisi */}
        {User.getPrivilage().indexOf("mitra-akuisisi") !== -1 ?
          <Route exact path="/merchant/mitra-akuisisi" component={MitraAkuisisiList} />
          : null}
        {User.getPrivilage().indexOf("mitra-akuisisi") !== -1 ?
          <Route exact path="/merchant/mitra-akuisisi/add" component={MitraAkuisisiAdd} />
          : null}
        {User.getPrivilage().indexOf("mitra-akuisisi") !== -1 ?
          <Route exact path="/merchant/mitra-akuisisi/edit/:id" component={MitraAkuisisiEdit} />
          : null}
        {User.getPrivilage().indexOf("mitra-akuisisi") !== -1 ?
          <Route exact path="/merchant/mitra-akuisisi/show/:id" component={MitraAkuisisiShow} />
          : null}
        
        {/* mitra akuisisi */}
        {User.getPrivilage().indexOf("fee-qris") !== -1 ?
          <Route exact path="/merchant/fee-qris" component={FeeQrisList} />
          : null}
        {User.getPrivilage().indexOf("fee-qris") !== -1 ?
          <Route exact path="/merchant/fee-qris/add" component={FeeQrisAdd} />
          : null}
        {User.getPrivilage().indexOf("fee-qris") !== -1 ?
          <Route exact path="/merchant/fee-qris/edit/:id" component={FeeQrisEdit} />
          : null}


      {/* merchant registraion  */}
      {User.getPrivilage().indexOf("merchant-registration") !== -1 ?
        <Route exact path="/merchant/registration" component={RegisterMerchant} />
        : null}
        
      {/* mobile */}
      {/* banner */}
      {User.getPrivilage().indexOf("banner") !== -1 ?
        <Route exact path="/mobile/banner" component={BannerList} />
        : null}
      {User.getPrivilage().indexOf("banner") !== -1 ?
        <Route exact path="/mobile/banner/add" component={BannerAdd} />
        : null}
      {User.getPrivilage().indexOf("banner") !== -1 ?
        <Route exact path="/mobile/banner/edit/:id" component={BannerEdit} />
        : null}
        
      {/* blastnotif */}
      {User.getPrivilage().indexOf("blast-notif") !== -1 ?
        <Route exact path="/mobile/blast-notif" component={BlastNotifList} />
        : null}
      {User.getPrivilage().indexOf("blast-notif") !== -1 ?
        <Route exact path="/mobile/blast-notif/add" component={BlastNotifAdd} />
        : null}
      {User.getPrivilage().indexOf("blast-notif") !== -1 ?
        <Route exact path="/mobile/blast-notif/edit/:id" component={BlastNotifEdit} />
        : null}
        
        {/* pos user */}
      {User.getPrivilage().indexOf("pos-user") !== -1 ?
        <Route exact path="/mobile/pos-user" component={POS_UserList} />
        : null}
        
        {/* pos price */}
      {User.getPrivilage().indexOf("pos-price") !== -1 ?
        <Route exact path="/mobile/pos-price" component={POS_PriceList} />
        : null}
      {User.getPrivilage().indexOf("pos-price") !== -1 ?
        <Route exact path="/mobile/pos-price/add" component={POS_PriceAdd} />
        : null}
      {User.getPrivilage().indexOf("pos-price") !== -1 ?
        <Route exact path="/mobile/pos-price/edit/:id" component={POS_PriceEdit} />
        : null}
  
  
      {/* merchant approval */}
      {User.IsLogin() && User.getPrivilage().indexOf("approval-merchants") !== -1 ? <div>

        <Route exact path="/merchant/approval" component={ApprovalMerchant} />
        <Route exact path="/merchant/approval/view/:id" component={ViewMerchant} />
        <Route exact path="/merchant/approval/edit-waiting-approval/:id" component={EditMerchantWaitingApproval} />
        <Route exact path="/merchant/approval/edit-approval-pten/:id" component={EditMerchantApprovalPten} />
        <Route exact path="/merchant/approval/edit-reject/:id" component={EditMerchantReject} />
      </div> : null}
      <Route exact path="/self-register" component={SelfRegister} />

      {/* Login  */}
    </div>
  )
}

class AppRoutes extends Component {
  render() {
    return (
      <Suspense fallback={<Spinner />}>
        <Switch>
          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/self-register" component={SelfRegister} />
          <Route exact path="/create-password" component={CreatePassword} />
          {
            User.IsLogin() ?
              <ProtectComponent /> :
              <Route path="/login" component={Login} />
          }
          {
            User.IsLogin() ?
              User.getPrivilage().indexOf("dashboard") == -1 ?
                <Redirect to="/" />
                : <Redirect to="/dashboard" />
              :
              <Redirect to="/login" />
          }
          {
          }
        </Switch>
      </Suspense>
    );
  }
}

export default AppRoutes;